import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-download',
  templateUrl: './download.component.html',
  styles: []
})
export class DownloadComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
